<template>
  <v-menu max-width="300" nudge-bottom="20">
    <template #activator="{ attr, on }">
      <v-icon v-bind="attr" v-on="on" small class="ml-2" color="warning">
        mdi-information-variant-circle-outline
      </v-icon>
    </template>
    <v-card class="pa-3" style="min-width: 220px">
      <div class="font-weight-bold mb-2">Card Size</div>

      <div class="text-caption mb-1">
        <strong>Small:</strong>
        Displays up to 6 cards simultaneously.
        <br />
        <strong>Medium:</strong>
        Displays up to 4 cards simultaneously.
        <br />
        <strong>Large:</strong>
        Displays up to 2 cards simultaneously.
      </div>
      <div class="text-caption grey--text">
        <span>
          Choose a card size to control how many quick info cards are visible at
          once and how much detail each card displays.
        </span>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "CardSizeInstruction",
};
</script>
